import { render, staticRenderFns } from "./SidebarStage.vue?vue&type=template&id=5a5a153c&scoped=true"
import script from "./SidebarStage.vue?vue&type=script&lang=js"
export * from "./SidebarStage.vue?vue&type=script&lang=js"
import style0 from "./SidebarStage.vue?vue&type=style&index=0&id=5a5a153c&prod&scoped=true&lang=css"
import style1 from "./SidebarStage.mobile.css?vue&type=style&index=1&id=5a5a153c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a153c",
  null
  
)

export default component.exports